import { render, staticRenderFns } from "./RipaList.vue?vue&type=template&id=fb7d7ec6"
import script from "./RipaList.vue?vue&type=script&lang=js"
export * from "./RipaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports